// @ts-nocheck

export type TicketGetWithTicketCommentsContactFromOwner = typeof TicketGetWithTicketCommentsContactFromOwner[keyof typeof TicketGetWithTicketCommentsContactFromOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactFromOwner = {
  true: 'true',
  false: 'false',
} as const;
